import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _ from 'lodash';
import { RadioElement, getDefaultCargoRequestValue, CONTAINER_TYPES, OWNER_TYPES, NOT_RESET_FIELDS, displayValue } from './common';
import { Checkbox, MenuItem, SelectField, TextField } from 'material-ui';

import CollapseCustomizable from 'components/common/CollapseCustomizable';
import { updateCargoOrder as updateCargoOrderAction } from 'actions/cargoes/orders';
import Tank from './Tank';
import General from './General';
import { fieldsMap, getValidateFields } from 'constants/validateFields';
import helpers from 'helpers';
import { getCargoByNameOrType } from 'services/cargoes/names';

function Container({
    updateCargoOrder,
    numberOrderTable,
    cargoPackingIndex,
    cargoOrder,
    cargoPacking,
    canCheck = false,
    cargoContainerDetails,
    errors,
    containerParentId,
}) {
    const [disabledAll, setDisableAll] = useState(false);
    const [isTank, setIsTank] = useState(false);
    const [isGeneral, setIsGenaral] = useState(false);
    const [containerTypes, setContainerTypes] = useState([]);

    useEffect(() => {
        if (
            cargoPacking.category !== 'container'
        ) {
            const { pack: metaPack } = getDefaultCargoRequestValue('packing');
            const details = getDefaultCargoRequestValue('containerDetails');

            NOT_RESET_FIELDS.forEach((field) => {
                metaPack[field] = cargoPacking.pack[field];
            });

            Object.values(fieldsMap).forEach(({ max }) => {
                cargoOrder.validateErrors = cargoOrder.validateErrors
                    .filter(obj => obj.field !== `packing.pack.${max}`);
            });

            setDisableAll(true);
            setIsTank(false);
            setIsGenaral(false);
            modifyFields([
                { field: 'packing.pack', value: metaPack },
                { field: 'containerDetails', value: details },
                { field: 'validateErrors', value: cargoOrder.validateErrors },
            ]);
        } else {
            setDisableAll(false);
        }
    }, [
        cargoPacking.category, 
    ]);

    useEffect(() => {
        const getContainerTypes = async () => {
            const { data } = await getCargoByNameOrType({ name: 'Container', type: containerParentId });
    
            setContainerTypes(data.map(i => _.pick(i, ['_id', 'name'])));
        };

        getContainerTypes();
    }, []);

    /**
     * @param {{ field: string, value: any }[]} changes 
     */
    const modifyFields = (changes) => {
        if (!Array.isArray(changes)) {
            changes = [changes];
        }

        const newCargoOrder = _.cloneDeep(cargoOrder);

        changes.forEach(({ field, value }) => {
            _.set(newCargoOrder.cargo[cargoPackingIndex], field, value);

            const fieldToValidate = getValidateFields(field);

            if (fieldToValidate) {
                const { min, max } = fieldToValidate;

                if (!newCargoOrder.cargo[cargoPackingIndex].packing.pack[max]) {
                    newCargoOrder.validateErrors = newCargoOrder.validateErrors
                        .filter(obj => obj.field !== `packing.pack.${max}`);
                } else if (
                    +newCargoOrder.cargo[cargoPackingIndex].packing.pack[min] > 
                    +(newCargoOrder.cargo[cargoPackingIndex].packing.pack[max] || 0)
                ) {
                    newCargoOrder.validateErrors.push({
                        field: `packing.pack.${max}`,
                        messages: ['Min is greater than max'],
                    });
                } else {
                    newCargoOrder.validateErrors = newCargoOrder.validateErrors
                        .filter(obj => obj.field !== `packing.pack.${max}`);
                }
            }
        });

        updateCargoOrder(numberOrderTable, newCargoOrder);
    };

    /**
     * @param {'general' | 'tank'} type 
     */
    const changeMode = (type) => {
        const metaDensity = getDefaultCargoRequestValue('density');

        const dropAllTankFields = [
            { field: 'packing.pack.densities', value: [metaDensity] },
            { field: 'packing.pack.pourPointMin', value: undefined },
            { field: 'packing.pack.pourPointMax', value: undefined },
            { field: 'packing.pack.boilingPointMin', value: undefined },
            { field: 'packing.pack.boilingPointMax', value: undefined },
            { field: 'packing.pack.meltingPointMin', value: undefined },
            { field: 'packing.pack.meltingPointMax', value: undefined },
            { field: 'packing.pack.flammable', value: false },
            { field: 'packing.pack.flashPointMin', value: undefined },
            { field: 'packing.pack.voyageHeatMin', value: undefined },
            { field: 'packing.pack.voyageHeatMax', value: undefined },
            { field: 'packing.pack.loadingHeatMin', value: undefined },
            { field: 'packing.pack.loadingHeatMax', value: undefined },
            { field: 'packing.pack.dischargeHeatMin', value: undefined },
            { field: 'packing.pack.dischargeHeatMax', value: undefined },
            { field: 'packing.pack.maxAdjacentHeat', value: undefined },
        ];

        const dropAllGeneralFields = [
            { 
                field: 'packing.pack.temperatureMin', 
                value: cargoPacking.pack.temperatureMin,
            },
            { 
                field: 'packing.pack.temperatureMax', 
                value: cargoPacking.pack.temperatureMax, 
            },
            { 
                field: 'packing.pack.moistureMin', 
                value: cargoPacking.pack.moistureMin, 
            },
            { 
                field: 'packing.pack.moistureMax', 
                value: cargoPacking.pack.moistureMax, 
            },
        ];

        if (type === 'general') {
            setIsGenaral(!isGeneral);
            setIsTank(false);
            modifyFields([
                ...dropAllTankFields,
                ...(!isGeneral ? dropAllGeneralFields : []),
            ]);
        } else {
            setIsTank(!isTank);
            setIsGenaral(false);
            modifyFields([
                ...dropAllGeneralFields,
                ...(!isTank ? dropAllTankFields : []),
            ]);
        }
    };

    const errorProps = {};

    if (!disabledAll) {
        errorProps.errorText = !cargoContainerDetails.kind;
    }

    return (<div><CollapseCustomizable 
        _key='container'
        head={
            <RadioElement 
                value='container' 
                checkedValue={cargoPacking.category}
                disabled={!canCheck}
                onCheck={() => modifyFields([{ field: 'packing.category', value: 'container' }])}
                label='container' 
                _key='container' 
            />
        }
        headStyle={{ borderBottom: '1px solid #E0E0E0' }}
        body={
            <React.Fragment>
                <div 
                    className='row'
                    style={{ width: '100%' }}
                >
                    <div className='col-xs-6'>
                        <SelectField 
                            value={cargoContainerDetails.kind || ''}
                            hintText='Type of Container*'
                            floatingLabelText='Type of Container*'
                            disabled={disabledAll}
                            underlineStyle={!disabledAll && !cargoContainerDetails.kind ? { borderColor: 'red' } : {}}
                            style={{ 
                                width: '100%',
                                fontSize: '13px',
                                marginRight: '15px',
                            }}
                            onChange={(_e, _i, value) => {
                                modifyFields([{ field: 'containerDetails.kind', value }]);
                            }}
                        >   
                            { containerTypes.map(item => (
                                <MenuItem 
                                    key={item._id}
                                    value={item._id}
                                    primaryText={item.name}
                                />))
                            }
                        </SelectField>
                    </div>
                    <div className='col-xs-3'>
                        <TextField 
                            value={cargoPacking.pack.bundlesQuantity || ''}
                            hintText='Quantity*'
                            floatingLabelText='Quantity*'
                            underlineStyle={!disabledAll && !cargoPacking.pack.bundlesQuantity ? { borderColor: 'red' } : {}}
                            disabled={!cargoContainerDetails.kind || disabledAll}
                            style={{ 
                                width: '100%',
                                fontSize: '13px',
                                marginRight: '15px',
                            }}
                            onChange={e => modifyFields([{
                                field: 'packing.pack.bundlesQuantity', 
                                value: helpers.clearLetters(e.target.value),
                            }])}
                        />
                    </div>
                </div>
                <div 
                    className='row'
                    style={{ width: '100%' }}
                >
                    <div className='col-xs-3'>
                        <TextField 
                            value={displayValue(
                                cargoPacking,
                                'pack.unitWeight.value', disabledAll,
                            )}
                            hintText='Unit Weight, mt'
                            floatingLabelText='Unit Weight, mt'
                            disabled={disabledAll}
                            style={{ 
                                width: '100%',
                                fontSize: '13px',
                                marginRight: '15px',
                            }}
                            onChange={e => modifyFields([{
                                field: 'packing.pack.unitWeight.value', 
                                value: helpers.clearLetters(e.target.value),
                            }])}
                        />
                    </div>
                    <div className='col-xs-3'>
                        <TextField 
                            value={cargoContainerDetails.ownNum || ''}
                            hintText='Container No'
                            floatingLabelText='Container No'
                            disabled={disabledAll}
                            style={{ 
                                width: '100%',
                                fontSize: '13px',
                                marginRight: '15px',
                            }}
                            onChange={e => modifyFields([{
                                field: 'containerDetails.ownNum', 
                                value: helpers.clearLetters(e.target.value),
                            }])}
                        />
                    </div>
                    <div className='col-xs-3'>
                        <TextField 
                            value={cargoContainerDetails.seal || ''}
                            hintText='Seal'
                            floatingLabelText='Seal'
                            disabled={disabledAll}
                            style={{ 
                                width: '100%',
                                fontSize: '13px',
                                marginRight: '15px',
                            }}
                            onChange={e => modifyFields([{
                                field: 'containerDetails.seal', 
                                value: helpers.clearLetters(e.target.value),
                            }])}
                        />
                    </div>
                    <div className='col-xs-3'>
                        <SelectField 
                            value={cargoContainerDetails.owner || 'shipper'}
                            hintText='Owner'
                            floatingLabelText='Owner'
                            disabled={disabledAll}
                            style={{ 
                                width: '100%',
                                fontSize: '13px',
                                marginRight: '15px',
                            }}
                            onChange={(_e, _i, value) => {
                                modifyFields([{
                                    field: 'containerDetails.owner', 
                                    value, 
                                }]);
                            }}
                        >   
                            { OWNER_TYPES.map(ownerType => (
                                <MenuItem 
                                    key={ownerType.name}
                                    value={ownerType.name}
                                    primaryText={ownerType.value}
                                />))
                            }
                        </SelectField>
                    </div>
                </div>
                <div 
                    className='row'
                    style={{ width: '100%' }}
                >
                    <div 
                        className='col-xs-3'
                        style={{ height: '48px', display: 'flex', alignItems: 'center' }}
                    >
                        CARGO
                    </div>
                    <div 
                        className='col-xs-3'
                        style={{ 
                            height: '48px', 
                            display: 'flex', 
                            alignItems: 'center',
                            flexDirection: 'row-reverse',
                        }}
                    >
                        MODE
                    </div>
                    <div 
                        className='col-xs-3'
                        style={{ height: '48px', display: 'flex', alignItems: 'center' }}
                    >
                        <Checkbox 
                            label='°C mode (General)'
                            checked={isGeneral}
                            disabled={disabledAll}
                            labelStyle={{ width: '100%' }}
                            onCheck={
                                () => changeMode('general')
                            }
                        />
                    </div>
                    <div 
                        className='col-xs-3'
                        style={{ height: '48px', display: 'flex', alignItems: 'center' }}
                    >
                        <Checkbox 
                            label='°C mode (Tank)'
                            checked={isTank}
                            disabled={disabledAll}
                            onCheck={
                                () => changeMode('tank')
                            }
                        />
                    </div>  
                </div>
                <div 
                    className='row'
                    style={{ width: '100%' }}
                >
                    <div className='col-xs-6'>
                        <TextField 
                            value={cargoContainerDetails.stc || ''}
                            hintText='STC'
                            floatingLabelText='STC'
                            disabled={disabledAll}
                            style={{ 
                                width: '100%',
                                fontSize: '13px',
                                marginRight: '15px',
                            }}
                            onChange={e => modifyFields([{
                                field: 'containerDetails.stc', 
                                value: e.target.value,
                            }])}
                        />
                    </div>
                    <div className='col-xs-3'>
                        <TextField 
                            value={cargoPacking.pack.netWeight.value || ''}
                            hintText='Total net weight, mt'
                            floatingLabelText='Total net weight, mt'
                            disabled={disabledAll}
                            style={{ 
                                width: '100%',
                                fontSize: '13px',
                                marginRight: '15px',
                            }}
                            onChange={e => modifyFields([{
                                field: 'packing.pack.netWeight.value', 
                                value: helpers.clearLetters(e.target.value),
                            }])}
                        />
                    </div>
                    <div className='col-xs-3'>
                        <TextField 
                            value={cargoPacking.pack.maxUnitLength.value || ''}
                            hintText='Max Length, mm'
                            floatingLabelText='Max Length, mm'
                            disabled={disabledAll}
                            style={{ 
                                width: '100%',
                                fontSize: '13px',
                                marginRight: '15px',
                            }}
                            onChange={e => modifyFields([{
                                field: 'packing.pack.maxUnitLength.value', 
                                value: helpers.clearLetters(e.target.value),
                            }])}
                        />
                    </div>
                </div>
                <div 
                    className='row'
                    style={{ width: '100%' }}
                >
                    <div className='col-xs-3'>
                        <TextField 
                            value={cargoPacking.pack.bundleBeam.value || ''}
                            hintText='Max Beam, mm'
                            floatingLabelText='Max Beam, mm'
                            disabled={disabledAll}
                            style={{ 
                                width: '100%',
                                fontSize: '13px',
                                marginRight: '15px',
                            }}
                            onChange={e => modifyFields([{
                                field: 'packing.pack.bundleBeam.value', 
                                value: helpers.clearLetters(e.target.value),
                            }])}
                        />
                    </div>
                    <div className='col-xs-3'>
                        <TextField 
                            value={cargoPacking.pack.bundleHeight.value || ''}
                            hintText='Max Height, mm'
                            floatingLabelText='Max Height, mm'
                            disabled={disabledAll}
                            style={{ 
                                width: '100%',
                                fontSize: '13px',
                                marginRight: '15px',
                            }}
                            onChange={e => modifyFields([{
                                field: 'packing.pack.bundleHeight.value', 
                                value: helpers.clearLetters(e.target.value),
                            }])}
                        />
                    </div>
                    <div className='col-xs-3'>
                        <TextField 
                            value={cargoPacking.pack.unitDiam.value || ''}
                            hintText='Max Diameter, mm'
                            floatingLabelText='Max Diameter, mm'
                            disabled={disabledAll}
                            style={{ 
                                width: '100%',
                                fontSize: '13px',
                                marginRight: '15px',
                            }}
                            onChange={e => modifyFields([{
                                field: 'packing.pack.unitDiam.value', 
                                value: helpers.clearLetters(e.target.value),
                            }])}
                        />
                    </div>
                </div>
                <div 
                    className='row'
                    style={{ width: '100%', height: '92px' }}
                >
                    <div className='col-xs-3'>
                        <TextField 
                            value={displayValue(
                                cargoPacking,
                                'pack.numberOfHeadsMin', disabledAll,
                            )}
                            hintText='Number of heads (min)'
                            floatingLabelText='Number of heads (min)'
                            disabled={disabledAll}
                            style={{ 
                                width: '100%',
                                fontSize: '13px',
                                marginRight: '15px',
                            }}
                            onChange={e => modifyFields([{
                                field: 'packing.pack.numberOfHeadsMin', 
                                value: helpers.clearLetters(e.target.value),
                            }])}
                        />
                    </div>
                    <div className='col-xs-3_flex'>
                        <TextField 
                            value={displayValue(
                                cargoPacking,
                                'pack.numberOfHeadsMax', disabledAll,
                            )}
                            errorText={errors.numberOfHeadsMax && errors.numberOfHeadsMax.messages[0]}
                            hintText='Number of heads (max)'
                            floatingLabelText='Number of heads (max)'
                            disabled={disabledAll}
                            style={{ 
                                width: '100%',
                                fontSize: '13px',
                                marginRight: '0px 5px',
                            }}
                            onChange={e => modifyFields([{
                                field: 'packing.pack.numberOfHeadsMax', 
                                value: helpers.clearLetters(e.target.value),
                            }])}
                        />
                    </div>
                    <div className='col-xs-3'>
                        <TextField 
                            value={displayValue(
                                cargoPacking,
                                'pack.weightPerHead', disabledAll,
                            )}
                            hintText='Weight mt per head'
                            floatingLabelText='Weight mt per head'
                            disabled={disabledAll}
                            style={{ 
                                width: '100%',
                                fontSize: '13px',
                                marginRight: '15px',
                            }}
                            onChange={e => modifyFields([{
                                field: 'packing.pack.weightPerHead', 
                                value: helpers.clearLetters(e.target.value),
                            }])}
                        />
                    </div>
                </div>
                {
                    isGeneral ?
                        <General 
                            cargoPacking={cargoPacking}
                            disabledAll={disabledAll}
                            modifyFields={modifyFields}
                            errors={errors}
                        />
                        : null
                }
                {
                    isTank ?
                        <Tank 
                            cargoPacking={cargoPacking}
                            category='container'
                            disabledAll={disabledAll}
                            modifyFields={modifyFields} 
                            errors={errors}
                        />
                        : null
                }
            </React.Fragment>
        }
    />
    </div>);
}

export default React.memo(connect(
    (state, ownProps) => {
        const cargoOrder = state.cargoOrders.items[ownProps.numberOrderTable];
        const cargoPacking = cargoOrder.cargo[ownProps.cargoPackingIndex].packing;
        const cargoContainerDetails = cargoOrder.cargo[ownProps.cargoPackingIndex].containerDetails || {};

        const containerParentId = state.cargoesNames.items.find(n => n.parent.red.name === 'Containers').parent.red._id;

        const errors = {
            pourPointMax: cargoOrder.validateErrors
                .find(validateError => validateError.field === 'packing.pack.pourPointMax'),
            boilingPointMax: cargoOrder.validateErrors
                .find(validateError => validateError.field === 'packing.pack.boilingPointMax'),
            meltingPointMax: cargoOrder.validateErrors
                .find(validateError => validateError.field === 'packing.pack.meltingPointMax'),

            voyageHeatMax: cargoOrder.validateErrors
                .find(validateError => validateError.field === 'packing.pack.voyageHeatMax'),
            loadingHeatMax: cargoOrder.validateErrors
                .find(validateError => validateError.field === 'packing.pack.loadingHeatMax'),
            dischargeHeatMax: cargoOrder.validateErrors
                .find(validateError => validateError.field === 'packing.pack.dischargeHeatMax'),
            numberOfHeadsMax: cargoOrder.validateErrors
                .find(validateError => validateError.field === 'packing.pack.numberOfHeadsMax'),

            temperatureMax: cargoOrder.validateErrors
                .find(validateError => validateError.field === 'packing.pack.temperatureMax'),
            moistureMax: cargoOrder.validateErrors
                .find(validateError => validateError.field === 'packing.pack.moistureMax'),
        };

        return {
            cargoOrder,
            cargoPacking,
            cargoContainerDetails,
            errors,
            containerParentId,
        };
    },
    dispatch => bindActionCreators({
        updateCargoOrder: updateCargoOrderAction,
    }, dispatch),
)(Container));




// WEBPACK FOOTER //
// ./app/components/Letters/SingleNew/Cargo/Sidebar/Order/Packing/Container.jsx